import usePrivateAxios from '@/common/api/usePrivateAxios'
import { UpdateUserAccessSchema } from '@/features/privateCompanies/schemas/politics/updateUserAccess.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateUserAccess {
  companyId?: string
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useUpdateUserAccess = ({ companyId, onSuccess, onError }: UseUpdateUserAccess) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateUserAccess'],
    mutationFn: async (data: UpdateUserAccessSchema) => {
      const company = {
        allowed_driver_equipment_branch_hierarchy_for_consumption:
          data.company?.allowed_driver_equipment_branch_hierarchy_for_consumption?.value || undefined,
        branch_hierarchy_for_user_access: data.company?.branch_hierarchy_for_user_access?.value || undefined,
        driver_license_requirements_for_consumptions:
          data.company?.driver_license_requirements_for_consumptions?.value || undefined,
      }

      await privateAxios.put(`/client/companies/${companyId}/update_users_access_configurations`, {
        company,
      })
    },
    onSuccess,
    onError,
  })
}
